import { useEffect, useState } from 'react';
import { PageHeader, Spinner, ErrorBanner, EmptyState } from '../components/ui';
import { projectsApi, type Project } from '../api/projects';

export default function Projects() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      setProjects(await projectsApi.list());
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { void load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    await projectsApi.create({ name: name.trim(), description: desc.trim() || undefined });
    setName(''); setDesc('');
    await load();
  };

  return (
    <div>
      <PageHeader title="Проекты" subtitle="Группировка чатов и документов" />
      {error && <ErrorBanner message={error} />}

      <div className="card mb-4 flex flex-wrap items-end gap-2">
        <div className="flex-1 min-w-[180px]">
          <label className="mb-1 block text-xs text-muted">Название</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Новый проект…" />
        </div>
        <div className="flex-1 min-w-[180px]">
          <label className="mb-1 block text-xs text-muted">Описание</label>
          <input className="input" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Необязательно" />
        </div>
        <button className="btn-primary" onClick={create}>Создать</button>
      </div>

      {loading ? <Spinner /> : projects.length === 0 ? (
        <EmptyState title="Нет проектов" />
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {projects.map((p) => (
            <div key={p.id} className="card flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-medium">{p.name}</div>
                {p.description && <p className="mt-1 text-xs text-muted">{p.description}</p>}
              </div>
              <button className="btn-danger px-2 py-1 text-xs" onClick={async () => { await projectsApi.remove(p.id); await load(); }}>Удалить</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
